import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import PublicNav from '../screens/landing-site/components/public-nav';
import DistrictFooter from './components/district-footer';
// An organization's view on a host that is not its own: the platform's navbar over the organization's footer.
const OrgStoryLayout = (props) => {
    return _jsxs(_Fragment, { children: [_jsx("div", { className: "public-page public-page--nav-only", children: _jsx(PublicNav, {}) }), _jsx("main", { children: props.children }), _jsx(DistrictFooter, { district: props.community })] });
};
export default OrgStoryLayout;
